import { cn } from '../lib/cn.js'

/**
 * Barra de categorias do cardápio e abas do portal. Rolagem horizontal com
 * scroll-snap: no celular, a categoria para alinhada em vez de meio cortada.
 */
export function Tabs({
  itens, ativo, aoTrocar, className,
}: {
  itens: { id: string; rotulo: string; contador?: number }[]
  ativo: string
  aoTrocar: (id: string) => void
  className?: string | undefined
}) {
  return (
    <div className={cn('du-abas', className)} role="tablist">
      {itens.map((i) => (
        <button
          key={i.id}
          type="button"
          role="tab"
          aria-selected={i.id === ativo}
          className={cn('du-abas__item', i.id === ativo && 'du-abas__item--ativo')}
          onClick={() => aoTrocar(i.id)}
        >
          {i.rotulo}
          {i.contador != null ? <span className="du-abas__contador">{i.contador}</span> : null}
        </button>
      ))}
    </div>
  )
}
